import { PermessoEntitaStoredProcedure, CategoriaPermessiStoredProcedure, PermessoStoredProcedure, EntitaStoredProcedure, getInternautaUrl, BaseUrlType, CUSTOM_SERVER_METHODS } from '@bds/internauta-model';
import * as i1 from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { UtilityFunctions as UtilityFunctions$1 } from '@bds/next-sdr';
import * as i0 from '@angular/core';
import { Injectable, Pipe, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import Bowser from 'bowser';
import { map } from 'rxjs/operators';

/**
 * identifica l'operazione da svolgere sul permesso
 */
var OggettoneOperation;
(function (OggettoneOperation) {
  OggettoneOperation[OggettoneOperation["ADD"] = 0] = "ADD";
  OggettoneOperation[OggettoneOperation["REMOVE"] = 1] = "REMOVE";
})(OggettoneOperation || (OggettoneOperation = {}));
/**
 * Classe che gestisce l'oggettone da passare alla manage permission della blackbox
 */
class OggettonePermessiEntitaGenerator {
  permessiEntita;
  constructor(permessiEntita) {
    if (!permessiEntita) {
      this.permessiEntita = [];
    } else {
      this.permessiEntita = permessiEntita;
    }
  }
  /**
   * aggiunge facendo eventuale merge le PermessoEntitaStoredProcedure passate a quelle già presenti nell'oggettone
   * @param permessiEntitaStoredProcedures le PermessoEntitaStoredProcedure da aggiungere
   */
  addPermessoEntitaStoredProcedures(permessiEntitaStoredProcedures) {
    permessiEntitaStoredProcedures.forEach(permessoEntita => {
      if (this.permessiEntita.length === 0) {
        // devo quindi creare tutto l'oggettone (soggetto, oggetto, con categoria)
        this.permessiEntita = permessiEntitaStoredProcedures;
      } else {
        // altrimenti devo cercare il PermessoEntitaStoredProcedure(soggetto, oggetto e categorie) da aggiornare, lo cerco tramite soggetto e oggetto
        const permessiEntitaIndex = this.findPermessoEntitaIndexBySoggettoOggetto(this.permessiEntita, permessoEntita.soggetto, permessoEntita.oggetto);
        // se trovo il PermessoEntitaStoredProcedure, allora devo vedere se esiste la categoria identificata da ambito e tipo passati come parametro
        if (permessiEntitaIndex >= 0) {
          const categorie = this.permessiEntita[permessiEntitaIndex].categorie;
          const categorieToAdd = permessoEntita.categorie;
          // controllo se esiste almeno una categoria
          if (categorie && categorie.length > 0) {
            // visto che esiste almeno una categoria, cerco la categoria identificata da ambito e tipo passati
            categorieToAdd.forEach(categoriaToAdd => {
              const categoriaIndex = this.findCategoriaIndexByAmbitoTipo(categorie, categoriaToAdd.ambito, categoriaToAdd.tipo);
              // se trovo la categoria cercata, devo andare a cercare al suo interno i permessi passati come parametro
              if (categoriaIndex >= 0) {
                const permessiOggettone = this.permessiEntita[permessiEntitaIndex].categorie[categoriaIndex].permessi;
                const permessiToAdd = categoriaToAdd.permessi;
                if (permessiOggettone && permessiOggettone.length > 0) {
                  permessiToAdd.forEach(permessoToAdd => {
                    const permessiIndex = this.findPermessoIndexByPredicato(permessiOggettone, permessoToAdd.predicato);
                    // cerco il permesso in base al predicato passato
                    if (permessiIndex >= 0) {
                      // dato che l'ho trovato, lo aggiorno
                      const permessoOggettoneAggiornato = this.updatePermesso(this.permessiEntita[permessiEntitaIndex].categorie[categoriaIndex].permessi[permessiIndex], permessoToAdd);
                      this.permessiEntita[permessiEntitaIndex].categorie[categoriaIndex].permessi[permessiIndex] = permessoOggettoneAggiornato;
                    } else {
                      // non ho trovato il pemesso
                      this.permessiEntita[permessiEntitaIndex].categorie[categoriaIndex].permessi.push(permessoToAdd);
                    }
                  });
                } else {
                  // può essere che non ci siano permessi
                  this.permessiEntita[permessiEntitaIndex].categorie[categoriaIndex].permessi = permessiToAdd;
                }
              } else {
                // non ho trovato la categoria cercata
                this.permessiEntita[permessiEntitaIndex].categorie.push(categoriaToAdd);
              }
            });
          } else {
            // può essere che non esistano categorie
            this.permessiEntita[permessiEntitaIndex].categorie = categorieToAdd;
          }
        } else {
          // non ho trovato il PermessoEntitaStoredProcedure
          this.permessiEntita.push(permessoEntita);
        }
      }
    });
  }
  getPermessiEntita() {
    return this.permessiEntita;
  }
  /**
   * aggiunge/aggiorna o rimuove un permesso. Lo aggiunge o lo rimuove in al posto giusto nell'oggettone
   * @param soggetto
   * @param oggetto
   * @param ambito
   * @param tipo
   * @param permessi
   * @param operation ADD o REMOVE
   */
  managePermessoOggettone(soggetto, oggetto, ambito, tipo, permessi, operation) {
    // se l'oggettone è vuoto allora devo sicuramente aggiungere tutto quello passato
    if (this.permessiEntita.length === 0 && operation === OggettoneOperation.ADD) {
      // devo quindi creare tutto l'oggettone (soggetto, oggetto, con categoria)
      this.permessiEntita.push(this.buildNewPermessoEntita(soggetto, oggetto, ambito, tipo, permessi));
    } else {
      // altrimenti devo cercare il PermessoEntitaStoredProcedure(soggetto, oggetto e categorie) da aggiornare, lo cerco tramite soggetto e oggetto
      const permessiEntitaIndex = this.findPermessoEntitaIndexBySoggettoOggetto(this.permessiEntita, soggetto, oggetto);
      // se trovo il PermessoEntitaStoredProcedure, allora devo vedere se esiste la categoria identificata da ambito e tipo passati come parametro
      if (permessiEntitaIndex >= 0) {
        const categorie = this.permessiEntita[permessiEntitaIndex].categorie;
        // controllo se esiste almeno una categoria
        if (categorie && categorie.length > 0) {
          // visto che esiste almeno una categoria, cerco la categoria identificata da ambito e tipo passati
          const categoriaIndex = this.findCategoriaIndexByAmbitoTipo(categorie, ambito, tipo);
          // se trovo la categoria cercata, devo andare a cercare al suo interno i permessi passati come parametro
          if (categoriaIndex >= 0) {
            const permessiOggettone = this.permessiEntita[permessiEntitaIndex].categorie[categoriaIndex].permessi;
            if (permessiOggettone && permessiOggettone.length > 0) {
              permessi.forEach(permesso => {
                const permessiIndex = this.findPermessoIndexByPredicato(permessiOggettone, permesso.predicato);
                // cerco il permesso in base al predicato passato
                if (permessiIndex >= 0) {
                  // dato che l'ho trovato, se devo aggiungere allora lo aggiorno
                  if (operation === OggettoneOperation.ADD) {
                    const permessoOggettoneAggiornato = this.updatePermesso(this.permessiEntita[permessiEntitaIndex].categorie[categoriaIndex].permessi[permessiIndex], permesso);
                    this.permessiEntita[permessiEntitaIndex].categorie[categoriaIndex].permessi[permessiIndex] = permessoOggettoneAggiornato;
                  } else {
                    // se devo rimuovore lo cancello
                    this.permessiEntita[permessiEntitaIndex].categorie[categoriaIndex].permessi.splice(permessiIndex, 1);
                  }
                } else {
                  // non ho trovato il pemesso
                  // se devo aggiugere lo aggiungo
                  if (operation === OggettoneOperation.ADD) {
                    this.permessiEntita[permessiEntitaIndex].categorie[categoriaIndex].permessi.push(permesso);
                  }
                }
              });
            } else {
              // può essere che non ci siano permessi
              // se devo aggiungere, allora creo il nuovo array con i permessi passati
              if (operation === OggettoneOperation.ADD) {
                this.permessiEntita[permessiEntitaIndex].categorie[categoriaIndex].permessi = permessi;
              }
            }
          } else {
            // non ho trovato la categoria cercata
            // se devo aggiungere la agguingo creandola nuova a partire dai dati passati
            if (operation === OggettoneOperation.ADD) {
              this.permessiEntita[permessiEntitaIndex].categorie.push(this.buildCategoria(ambito, tipo, permessi));
            }
          }
        } else {
          // può essere che non esistano categorie
          // se devo aggiungere creo il nuovo array con la categoria creata a partire dai dati passati (ambito, tipo, permessi)
          if (operation === OggettoneOperation.ADD) {
            this.permessiEntita[permessiEntitaIndex].categorie = [this.buildCategoria(ambito, tipo, permessi)];
          }
        }
      } else {
        // non ho trovato il PermessoEntitaStoredProcedure
        // se devo aggiungere, allora lo creo nuovo a partire dai dati passati
        if (operation === OggettoneOperation.ADD) {
          this.permessiEntita.push(this.buildNewPermessoEntita(soggetto, oggetto, ambito, tipo, permessi));
        }
      }
    }
  }
  /**
   * Verifica se il soggetto ha un permesso
   * @param soggetto
   * @param oggetto
   * @param ambito
   * @param tipo
   * @param permessi
   * @returns True se il soggetto ha il permesso, False altrimenti
   */
  userHasPermission(soggetto, oggetto, ambito, tipo, permessi) {
    const permessiEntitaIndex = this.findPermessoEntitaIndexBySoggettoOggetto(this.permessiEntita, soggetto, oggetto);
    // se trovo il PermessoEntitaStoredProcedure, allora devo vedere se esiste la categoria identificata da ambito e tipo passati come parametro
    if (permessiEntitaIndex >= 0) {
      const categorie = this.permessiEntita[permessiEntitaIndex].categorie;
      // controllo se esiste almeno una categoria
      if (categorie && categorie.length > 0) {
        // visto che esiste almeno una categoria, cerco la categoria identificata da ambito e tipo passati
        const categoriaIndex = this.findCategoriaIndexByAmbitoTipo(categorie, ambito, tipo);
        // se trovo la categoria cercata, devo andare a cercare al suo interno i permessi passati come parametro
        if (categoriaIndex >= 0) {
          const permessiOggettone = this.permessiEntita[permessiEntitaIndex].categorie[categoriaIndex].permessi;
          if (permessiOggettone && permessiOggettone.length > 0) {
            let permessiIndex;
            permessi.forEach(permesso => {
              permessiIndex = this.findPermessoIndexByPredicato(permessiOggettone, permesso.predicato);
              // cerco il permesso in base al predicato passato
            });
            if (permessiIndex >= 0) {
              // Permesso trovato
              return true;
            }
          }
        }
      }
    }
    return false;
  }
  /**
   * aggiorna un permesso, solo se è da aggiornare. Aggiorna solo i campi passati in permessoNuovo
   * @param permessoOggettone il permesso da aggiornare
   * @param permessoNuovo il permesso con i dati nuovi
   */
  updatePermesso(permessoOggettone, permessoNuovo) {
    const now = new Date();
    let res = permessoOggettone;
    // posso aggiornare solo se il permesso è nel fututo o ancora in corso
    if (!permessoOggettone.attivo_al || permessoOggettone.attivo_al > now) {
      // non posso fare iniziare un permesso nel passato, per cui se ho passato attivoDal nel passato, non faccio niente
      if (permessoNuovo.attivo_dal && permessoNuovo.attivo_dal >= now) {
        // se il permesso non è ancora iniziato, posso aggiornare la data di partenza, altrimenti no
        if (permessoOggettone.attivo_dal > now) {
          if (permessoNuovo.attivo_dal) {
            res.attivo_dal = permessoNuovo.attivo_dal;
          }
        }
        // aggiorno tutti gli altri campi (se mi sono stati passati)
        if (permessoNuovo.attivo_al) {
          res.attivo_al = permessoNuovo.attivo_al;
        }
        if (permessoNuovo.data_inserimento_riga) {
          res.data_inserimento_riga = permessoNuovo.data_inserimento_riga;
        }
        if (permessoNuovo.data_ultima_modifica) {
          res.data_ultima_modifica = permessoNuovo.data_ultima_modifica;
        }
        if (permessoNuovo.id_permesso_bloccato) {
          res.id_permesso_bloccato = permessoNuovo.id_permesso_bloccato;
        }
        if (permessoNuovo.origine_permesso) {
          res.origine_permesso = permessoNuovo.origine_permesso;
        }
        if (permessoNuovo.propaga_oggetto) {
          res.propaga_oggetto = permessoNuovo.propaga_oggetto;
        }
        if (permessoNuovo.propaga_soggetto) {
          res.propaga_soggetto = permessoNuovo.propaga_soggetto;
        }
        if (permessoNuovo.virtuale) {
          res.virtuale = permessoNuovo.virtuale;
        }
      }
    }
    return res;
  }
  // tslint:disable-next-line:max-line-length
  findPermessoIndexByPredicato(permessi, predicato) {
    return permessi.findIndex(p => p.predicato === predicato);
  }
  // tslint:disable-next-line:max-line-length
  findPermessoEntitaIndexBySoggettoOggetto(permessiEntita, soggetto, oggetto) {
    return permessiEntita.findIndex(pe => pe.soggetto.schema === soggetto.schema && pe.soggetto.table === soggetto.table && pe.soggetto.id_provenienza === soggetto.id_provenienza && pe.oggetto.schema === oggetto.schema && pe.oggetto.table === oggetto.table && pe.oggetto.id_provenienza === oggetto.id_provenienza);
  }
  // tslint:disable-next-line:max-line-length
  findCategoriaIndexByAmbitoTipo(categorie, ambito, tipo) {
    return categorie.findIndex(c => c.ambito === ambito && c.tipo === tipo);
  }
  buildNewPermessoEntita(soggetto, oggetto, ambito, tipo, permessi) {
    const permessoEntita = new PermessoEntitaStoredProcedure();
    permessoEntita.soggetto = soggetto;
    permessoEntita.oggetto = oggetto;
    permessoEntita.categorie = [this.buildCategoria(ambito, tipo, permessi)];
    return permessoEntita;
  }
  buildCategoria(ambito, tipo, permessi) {
    const categoriaPermessiStoredProcedure = new CategoriaPermessiStoredProcedure();
    categoriaPermessiStoredProcedure.ambito = ambito;
    categoriaPermessiStoredProcedure.tipo = tipo;
    categoriaPermessiStoredProcedure.permessi = permessi;
    return categoriaPermessiStoredProcedure;
  }
  buildPermesso(predicato, propaga_soggetto, propaga_oggetto, virtuale, origine_permesso, id_permesso_bloccato, attivo_dal, attivo_al, entita_veicolante) {
    const permessoStoredProcedure = new PermessoStoredProcedure();
    permessoStoredProcedure.predicato = predicato;
    permessoStoredProcedure.propaga_soggetto = propaga_soggetto;
    permessoStoredProcedure.propaga_oggetto = propaga_oggetto;
    permessoStoredProcedure.origine_permesso = origine_permesso;
    permessoStoredProcedure.id_permesso_bloccato = id_permesso_bloccato;
    permessoStoredProcedure.virtuale = virtuale;
    permessoStoredProcedure.attivo_dal = attivo_dal;
    permessoStoredProcedure.attivo_al = attivo_al;
    permessoStoredProcedure.entita_veicolante = entita_veicolante;
    return permessoStoredProcedure;
  }
  buildPermessoDaEliminare(predicato) {
    const permessoStoredProcedure = this.buildPermesso(predicato, false, false, false, null, null, null, null, null);
    return permessoStoredProcedure;
  }
  buildEntita(idProvenienza, entitaBlackbox) {
    let entita = new EntitaStoredProcedure();
    const entitaOggettone = getEntita(entitaBlackbox);
    entita.id_provenienza = idProvenienza;
    entita.schema = entitaOggettone.schema;
    entita.table = entitaOggettone.tabella;
    return entita;
  }
}
var EntitaBlackbox;
(function (EntitaBlackbox) {
  EntitaBlackbox[EntitaBlackbox["UTENTI"] = 0] = "UTENTI";
  EntitaBlackbox[EntitaBlackbox["ARCHIVI"] = 1] = "ARCHIVI";
  EntitaBlackbox[EntitaBlackbox["PEC"] = 2] = "PEC";
  EntitaBlackbox[EntitaBlackbox["STRUTTURE"] = 3] = "STRUTTURE";
  EntitaBlackbox[EntitaBlackbox["PERSONE"] = 4] = "PERSONE";
  EntitaBlackbox[EntitaBlackbox["CONTATTI"] = 5] = "CONTATTI";
})(EntitaBlackbox || (EntitaBlackbox = {}));
function getEntita(entitaBlackbox) {
  switch (entitaBlackbox) {
    case EntitaBlackbox.PERSONE:
      return {
        schema: "baborg",
        tabella: "persone"
      };
    case EntitaBlackbox.STRUTTURE:
      return {
        schema: "baborg",
        tabella: "strutture"
      };
    case EntitaBlackbox.PEC:
      return {
        schema: "baborg",
        tabella: "pec"
      };
    case EntitaBlackbox.ARCHIVI:
      return {
        schema: "scripta",
        tabella: "archivi"
      };
    case EntitaBlackbox.UTENTI:
      return {
        schema: "baborg",
        tabella: "utenti"
      };
    case EntitaBlackbox.CONTATTI:
      return {
        schema: "rubrica",
        tabella: "contatti"
      };
  }
}
class PermissionManagerService {
  _http;
  permissionBaseUrl;
  datepipe;
  constructor(_http, permissionBaseUrl, datepipe) {
    this._http = _http;
    this.permissionBaseUrl = permissionBaseUrl;
    this.datepipe = datepipe;
  }
  managePermission(permessi) {
    return this._http.post(this.permissionBaseUrl + "/managePermissions", UtilityFunctions$1.cleanArrayForHttpCall(permessi, this.datepipe));
  }
  managePermissionsGestoriPec(json) {
    return this._http.post(this.permissionBaseUrl + "/managePermissionsGestoriPec", UtilityFunctions$1.cleanArrayForHttpCall(json, this.datepipe));
  }
  managePermissionsAssociazioniPecStruttura(json) {
    return this._http.post(this.permissionBaseUrl + "/managePermissionsAssociazioniPecStruttura", UtilityFunctions$1.cleanArrayForHttpCall(json, this.datepipe));
  }
  //da aggiungere un nuovo valore alla mappa ma renderlo retrocompatibile con le altre menagePermissionAdvanced
  managePermissionsAdvanced(permessi, permessiAggiunti, dataDiLavoro, ambitiInteressati, tipiInteressati, additionalData) {
    let permessiAggiuntiCleaned = null;
    let pDataDiLavoro = null;
    if (permessiAggiunti) {
      permessiAggiuntiCleaned = UtilityFunctions$1.cleanArrayForHttpCall(permessiAggiunti, this.datepipe);
    }
    if (dataDiLavoro) {
      pDataDiLavoro = dataDiLavoro.getTime();
    }
    return this._http.post(this.permissionBaseUrl + "/managePermissionsAdvanced", {
      permessiEntita: UtilityFunctions$1.cleanArrayForHttpCall(permessi, this.datepipe),
      permessiAggiunti: permessiAggiuntiCleaned,
      dataDiLavoro: pDataDiLavoro,
      ambitiInteressati: ambitiInteressati,
      tipiInteressati: tipiInteressati,
      additionalData: additionalData
    });
  }
  //permessi del passato di un archivio. Al momento torna solo i permessi VICARIO e RESPONSABILE
  getStoricoPermessiArchivio(idArchivio, onlyPermissionsOfConnectedPersona = false) {
    const urlDaChiamare = getInternautaUrl(BaseUrlType.Permessi);
    const params = new HttpParams().set("idArchivio", idArchivio.toString()).set("onlyPermissionsOfConnectedPersona", onlyPermissionsOfConnectedPersona.toString());
    return this._http.get(urlDaChiamare + "/getStoricoPermessiArchivio", {
      params: params
    });
  }
}
class IntimusCommand {
  _command;
  _params;
  IntimusCommandParams;
  constructor(command, params) {
    this._command = IntimusCommands[command];
    this._params = params;
  }
  get command() {
    return this._command;
  }
  set command(command) {
    this._command = command;
  }
  get params() {
    return this._params;
  }
  set params(params) {
    this._params = params;
  }
}
var IntimusCommands;
(function (IntimusCommands) {
  IntimusCommands["RefreshMails"] = "RefreshMails";
  IntimusCommands["RefreshAttivita"] = "RefreshAttivita";
  IntimusCommands["ShowMessage"] = "ShowMessage";
  IntimusCommands["Logout"] = "Logout";
})(IntimusCommands || (IntimusCommands = {}));
var RefreshMailsParamsOperations;
(function (RefreshMailsParamsOperations) {
  RefreshMailsParamsOperations["INSERT"] = "INSERT";
  RefreshMailsParamsOperations["UPDATE"] = "UPDATE";
  RefreshMailsParamsOperations["DELETE"] = "DELETE";
})(RefreshMailsParamsOperations || (RefreshMailsParamsOperations = {}));
var RefreshMailsParamsEntities;
(function (RefreshMailsParamsEntities) {
  RefreshMailsParamsEntities["MESSAGE"] = "MESSAGE";
  RefreshMailsParamsEntities["MESSAGE_TAG"] = "MESSAGE_TAG";
  RefreshMailsParamsEntities["MESSAGE_FOLDER"] = "MESSAGE_FOLDER";
  RefreshMailsParamsEntities["OUTBOX"] = "OUTBOX";
  RefreshMailsParamsEntities["DRAFT"] = "DRAFT";
})(RefreshMailsParamsEntities || (RefreshMailsParamsEntities = {}));
class IntimusClientService {
  initialized = false;
  _command$ = new Subject();
  constructor() {}
  start(intimusUrl, application, idPersona, idAzienda, idAziende) {
    if (!this.initialized && idPersona && idAzienda) {
      this.initializeIntimus(intimusUrl, application, idPersona, idAzienda, idAziende);
      this.initialized = true;
    }
  }
  initializeIntimus(intimusUrl, application, idPersona, idAzienda, idAziende) {
    // const primusUrl = getInternautaUrl(BaseUrlType.Intimus);
    const primus = Primus.connect(intimusUrl, {
      reconnect: {
        maxDelay: 10000,
        // Number: The max delay for a reconnect retry.
        minDelay: 500,
        // Number: The minimum delay before we reconnect.
        retries: Infinity // Number: How many times should we attempt to reconnect.
      }
    });
    primus.on("data", data => {
      console.log("**********Received a new message from the server*************", data);
      if (data.command === "registerClient") {
        // console.log("Received a new message from the server", data);
        this.registerClient(primus, application, idPersona, idAzienda, idAziende);
      } else if (data && data.command) {
        const cmd = data.command + "&params=" + JSON.stringify(data.params);
        const intimusCommand = new IntimusCommand(data.command, data.params);
        this.pushCommand(intimusCommand);
        // console.log("Received command from the server", cmd);
      } else {
        // console.log(JSON.stringify(data));
      }
    });
    primus.on("open", () => {
      this.registerClient(primus, application, idPersona, idAzienda, idAziende);
    });
  }
  registerClient(primus, application, idPersona, idAzienda, idAziende) {
    const clientInfo = {
      command: "registerClient",
      params: {
        user: idPersona,
        id_azienda: idAzienda,
        id_aziende: idAziende,
        application: application,
        browserinfo: Bowser.getParser(window.navigator.userAgent),
        ip: null,
        resolution: this.getScreenResolution()
      }
    };
    primus.write(clientInfo);
  }
  getScreenResolution() {
    if (Math.abs(window.orientation) - 90 === 0) {
      return screen.height + "x" + screen.width;
    } else {
      return screen.width + "x" + screen.height;
    }
  }
  pushCommand(intimusCommand) {
    this._command$.next(intimusCommand);
  }
  get command$() {
    return this._command$.asObservable();
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: IntimusClientService,
    deps: [],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: IntimusClientService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: IntimusClientService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => []
});
class CsvExtractor {
  isFunction = obj => !!(obj && obj.constructor && obj.call && obj.apply);
  /**
   * Si occupa di scavare dentro un oggetto attraverso una stringa che rappresenta il path da seguire
   * @param data
   * @param field
   */
  splitStringAndGetValueObject(data, field) {
    const fields = field.split(".");
    let value = data;
    for (let i = 0, len = fields.length; i < len; ++i) {
      if (value == null) {
        return null;
      }
      value = value[fields[i]];
    }
    return value;
  }
  /**
   * Se value è un boolean ritorna una stringa Si/No a seconda del valore, altrimenti restituisce value così com'è
   * @param value
   */
  convertValueIfBoolean(value, column) {
    let res = value === true ? "Si" : value === false ? "No" : value;
    if ((res === undefined || res === null) && column && column.fieldType && column.fieldType === "boolean") {
      res = false;
    }
    return res;
  }
  /**
   * Si occupa di costruire una stringa a partire da un array e da un identificativo del campo con cui costruire la medesima
   */
  /* private buildValueForArrayField(data: any, arrayField: string, objectField: string, token: string) {
        let value = "";
        if (data[arrayField]) {
            for (const el of data[arrayField]) {
                value += this.splitStringAndGetValueObject(el, objectField) + token;
            }
            if (value.length > 0) {
                value = value.substring(0, value.length - token.length);
            }
        }
        return value;
    } */
  /**
   * Estrae il contenuto del campo field dal record data passati come parametri
   * @param field Chiave del campo
   * @param data Record da cui estrarre il campo
   * */
  resolveFieldData(data, field, column) {
    if (data && field) {
      if (this.isFunction(field)) {
        return this.convertValueIfBoolean(field(data), column);
        /* } else if (column && column.addtionalInfoCsv) {
                if (column.addtionalInfoCsv.type === "list") {
                    return this.buildValueForArrayField(data, column.addtionalInfoCsv.arrayField,
                            column.addtionalInfoCsv.objectField, column.addtionalInfoCsv.token);
                } else if (column.addtionalInfoCsv.type === "function") {
                    return column.addtionalInfoCsv.exe(data);
                }
                return null; */
      } else if (field.indexOf(".") === -1) {
        return this.convertValueIfBoolean(data[field], column);
      } else {
        return this.convertValueIfBoolean(this.splitStringAndGetValueObject(data, field), column);
      }
    } else {
      return null;
    }
  }
  /**
   * Genera e lancia il download del file CSV di una tabella
   * @param table Tabella
   */
  exportCsv(table) {
    const data = table.filteredValue || table.value;
    let csv = ""; //\ufeff
    // headers
    for (let i = 0; i < table.columns.length; i++) {
      const column = table.columns[i];
      if (column.exportable !== false && column.field) {
        csv += '"' + (column.header || column.field) + '"';
        if (i < table.columns.length - 1) {
          csv += table.csvSeparator;
        }
      }
    }
    // body
    if (data) {
      data.forEach((record, i) => {
        csv += "\n";
        for (let j = 0; j < table.columns.length; j++) {
          const column = table.columns[j];
          if (column.exportable !== false && column.field) {
            const cellData = [];
            if (column.subfields) {
              column.subfields.forEach(element => {
                cellData.push(this.resolveFieldData(record, element));
              });
            } else {
              cellData.push(this.resolveFieldData(record, column.field, column));
            }
            csv += '"'; // Delimitatore iniziale del campo
            for (let k = 0; k < cellData.length; k++) {
              if (cellData[k] !== null) {
                cellData[k] = String(cellData[k]).replace(/"/g, '""');
              } else {
                cellData[k] = "";
              }
              if (column.separator) {
                csv += cellData[k] + column.separator[k]; // Separatore dei campi calcolati
              } else {
                csv += cellData[k];
              }
            }
            csv += '"'; // Delimitatore finale del campo
            if (j < table.columns.length - 1) {
              csv += table.csvSeparator;
            }
          }
        }
      });
    }
    const blob = new Blob([csv], {
      type: "text/csv;charset=utf-8;"
    });
    const nav = window.navigator;
    if (nav.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(blob, table.exportFilename + ".csv");
    } else {
      const link = document.createElement("a");
      link.style.display = "none";
      document.body.appendChild(link);
      if (link.download !== undefined) {
        link.setAttribute("href", URL.createObjectURL(blob));
        link.setAttribute("download", table.exportFilename + ".csv");
        link.click();
      } else {
        csv = "data:text/csv;charset=utf-8," + csv;
        window.open(encodeURI(csv));
      }
      document.body.removeChild(link);
    }
  }
}
class GenericTreeBds {
  /**
   * Converts a list of JSON tree nodes to a list of PrimeNG `TreeNode` objects.
   *
   * @param jsonTreeNodeList - The list of JSON tree nodes to convert.
   * @param iconExpanded - The icon to use for expanded tree nodes.
   * @param iconCollapsed - The icon to use for collapsed tree nodes.
   * @returns The list of PrimeNG `TreeNode` objects.
   */
  castToPrimengTreeNodeList(jsonTreeNodeList, originTreeId, iconExpanded, iconCollapsed) {
    const treeNodeList = [];
    jsonTreeNodeList.forEach(node => {
      const primengTreeNode = this.castToPrimengSingleTreeNode(node, originTreeId, iconExpanded, iconCollapsed);
      treeNodeList.push(primengTreeNode);
    });
    return treeNodeList;
  }
  /**
   * Converts a single JSON tree node to a PrimeNG `TreeNode` object.
   *
   * @param jsonTreeNode - The JSON tree node to convert.
   * @param iconExpanded - The icon to use for the expanded state of the tree node.
   * @param iconCollapsed - The icon to use for the collapsed state of the tree node.
   * @returns The PrimeNG `TreeNode` object.
   */
  castToPrimengSingleTreeNode(jsonTreeNode, originTreeId, iconExpanded, iconCollapsed) {
    const primengTreeNode = {};
    primengTreeNode.label = "";
    if (jsonTreeNode.description) {
      primengTreeNode.label = jsonTreeNode.description;
    }
    //creo oggetto da mettere dentro 'data'. Sarà un oggetto contenente più chiavi
    const jsonData = {
      object: jsonTreeNode.object,
      originTreeId: originTreeId,
      additionalInformations: jsonTreeNode.objectsMap ? jsonTreeNode.objectsMap : []
    };
    primengTreeNode.data = jsonData;
    if (jsonTreeNode.key) {
      primengTreeNode.key = jsonTreeNode.key;
    }
    if (jsonTreeNode.children) {
      const childrens = jsonTreeNode.children;
      if (iconCollapsed) {
        primengTreeNode.collapsedIcon = iconCollapsed;
      }
      if (iconExpanded) {
        primengTreeNode.expandedIcon = iconExpanded;
      }
      //se ci sono figli casto prima quelli
      if (childrens.length > 0) {
        let treeNodeChildrens = [];
        treeNodeChildrens = this.castToPrimengTreeNodeList(childrens, originTreeId, iconExpanded, iconCollapsed);
        primengTreeNode.children = treeNodeChildrens;
      }
    }
    return primengTreeNode;
  }
  castToGenericTreeList(primengTtreeNode, originTreeId = null, alsoChildren = true) {
    const treeNodeList = [];
    primengTtreeNode.forEach(node => {
      const primengTreeNode = this.castToGenericTreeSingleTreeNode(node, originTreeId, alsoChildren);
      treeNodeList.push(primengTreeNode);
    });
    return treeNodeList;
  }
  castToGenericTreeSingleTreeNode(treeNode, originTreeId = null, alsoChildren = true) {
    const genericTreeNode = {};
    genericTreeNode.description = "";
    if (treeNode.label) {
      genericTreeNode.description = treeNode.description;
    }
    // creo oggetto da mettere dentro 'data'. Sarà un oggetto contenente più chiavi
    // const jsonData = {
    //   object: treeNode.object,
    //   originTreeId: originTreeId,
    // };
    let obj = treeNode.data.object;
    genericTreeNode.object = obj;
    if (treeNode.key) {
      genericTreeNode.key = treeNode.key;
    }
    if (alsoChildren && treeNode.children) {
      const childrens = treeNode.children;
      //se ci sono figli casto prima quelli
      if (childrens.length > 0) {
        let treeNodeChildrens = [];
        treeNodeChildrens = this.castToGenericTreeList(childrens);
        genericTreeNode.children = treeNodeChildrens;
      }
    }
    return genericTreeNode;
  }
}
class BackendUtilityService {
  _http;
  constructor(_http) {
    this._http = _http;
  }
  newDate(url) {
    let data;
    return this._http.get(url + "/newdate").pipe(map(dateString => {
      return new Date(dateString);
    })).toPromise();
  }
  /*
  chiamata per scaricare il modello CSV per importare i contatti in rubrica
  */
  getCsvFileFromRemote(idAzienda, idApplicazione, filename) {
    const url = new URL(CUSTOM_SERVER_METHODS.downloadCSVModel, getInternautaUrl(BaseUrlType.Tools) + "/");
    url.searchParams.append("idAzienda", idAzienda.toString());
    url.searchParams.append("idApplicazione", idApplicazione);
    url.searchParams.append("filename", filename);
    const httpOptions = {
      responseType: "blob"
    };
    return this._http.get(url.toString(), httpOptions);
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: BackendUtilityService,
    deps: [{
      token: i1.HttpClient
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: BackendUtilityService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: BackendUtilityService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }]
});

/**
 * This class provides a set of methods to manage filters for a table.
 * The immediateFiltering propery is used to decide if the filters should be applied immediately or should be stored for future application of it.
 */
class GenericFilterService {
  _immediateFiltering = true;
  _storedFilters = {};
  _scopeOfMethods;
  _atLeastOneFilterToApply = false;
  get immediateFiltering() {
    return this._immediateFiltering;
  }
  set immediateFiltering(immediateFiltering) {
    this._immediateFiltering = immediateFiltering;
  }
  get storedFilters() {
    return this._storedFilters;
  }
  set storedFilters(storedFilters) {
    this._storedFilters = storedFilters;
  }
  get scopeOfMethods() {
    return this._scopeOfMethods;
  }
  set scopeOfMethods(scopeOfMethods) {
    this._scopeOfMethods = scopeOfMethods;
  }
  get atLeastOneFilterToApply() {
    return this._atLeastOneFilterToApply;
  }
  set atLeastOneFilterToApply(atLeastOneFilterToApply) {
    this._atLeastOneFilterToApply = atLeastOneFilterToApply;
  }
  /**
   * Builds and adds a new filter GenericFilter to the list of filters.
   *
   * @param field - The field to filter on.
   * @param filterMethod - The filter method to apply.
   * @param args - The arguments to pass to the filter method.
   */
  buildAndAddFilter(field, filterMethod, hasFilterToApply, ...args) {
    console.log("this", this);
    this.addFilter({
      field: field,
      filterMethod: filterMethod,
      hasFilterToApply: hasFilterToApply,
      argsFilterMethod: args
    });
  }
  /**
   * Adds a new filter to the list of active filters.
   * If `immediateFiltering` is true, the filter is applied immediately.
   * Otherwise, the filter is stored for later application.
   *
   * @param filter The filter to add.
   */
  addFilter(filter) {
    this.storeFilter(filter);
    if (this.immediateFiltering) {
      this.applyFilter(filter);
    } else {
      this.atLeastOneFilterToApply = true;
    }
  }
  /**
   * Applies the provided filter.
   *
   * @param filter - The filter to apply.
   */
  applyFilter(filter) {
    console.log("this", this);
    if (filter) {
      const filterMethod = filter.filterMethod;
      const argsFilterMethod = filter.argsFilterMethod;
      filterMethod.call(this.scopeOfMethods, ...argsFilterMethod);
      filter.hasFilterToApply = false;
    }
  }
  /**
   * Applies the provided filters.
   *
   */
  applyStoredFilters(/* storedFilters: StoredFilters */
  ) {
    console.log("this", this);
    for (const [key, value] of Object.entries(this.storedFilters)) {
      this.applyFilter(value);
    }
    this.atLeastOneFilterToApply = false;
  }
  /// Stores the provided GenericFilter object in the storedFilters map, using the filter's field property as the key.
  storeFilter(filterToStore) {
    this.storedFilters[filterToStore.field] = filterToStore;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: GenericFilterService,
    deps: [],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: GenericFilterService
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: GenericFilterService,
  decorators: [{
    type: Injectable
  }]
});
class BeautifyEnumPipe {
  transform(value) {
    if (!value) return value;
    const v = value.toLowerCase() /* .replaceAll("_", " ") */.replace("_", " ").replace("_", " ").replace("_", " ");
    return v.charAt(0).toUpperCase() + v.slice(1);
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: BeautifyEnumPipe,
    deps: [],
    target: i0.ɵɵFactoryTarget.Pipe
  });
  /** @nocollapse */
  static ɵpipe = i0.ɵɵngDeclarePipe({
    minVersion: "14.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: BeautifyEnumPipe,
    isStandalone: false,
    name: "beautifyEnum"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: BeautifyEnumPipe,
  decorators: [{
    type: Pipe,
    args: [{
      name: "beautifyEnum",
      standalone: false
    }]
  }]
});
const LOCAL_IT = {
  firstDayOfWeek: 1,
  dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
  dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
  dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
  monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
  monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
  today: "Oggi",
  clear: "Svuota"
};
const PRIMENG_ITA_TRANSALATION = {
  startsWith: "Inizia per",
  contains: "Contiene",
  notContains: "Non contiene",
  endsWith: "Finisce per",
  equals: "Uguale",
  notEquals: "Diverso",
  noFilter: "Nessun filtro",
  lt: "Minore di",
  lte: "Minore di o uguale a",
  gt: "Maggiore di",
  gte: "Maggiore di o uguale a",
  is: "É",
  isNot: "Non è",
  before: "Prima",
  after: "Dopo",
  dateIs: "La data è",
  dateIsNot: "La data non è",
  dateBefore: "La data è prima del",
  dateAfter: "La data è dopo il",
  clear: "Svuota",
  apply: "Applica",
  matchAll: "Uguale a tutti",
  matchAny: "Uguale a uno tra",
  addRule: "Aggiungi regola",
  removeRule: "Rimuovi regola",
  accept: "Sì",
  reject: "No",
  choose: "Scegli",
  upload: "Carica",
  cancel: "Svuota",
  dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
  dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
  dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
  monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
  monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
  /* "dateFormat": "mm/dd/yy", */
  today: "Oggi",
  weekHeader: "St",
  weak: "Debole",
  medium: "Medio",
  strong: "Forte",
  passwordPrompt: "Inserire password",
  emptyMessage: "Nessun risultato trovato",
  emptyFilterMessage: "Nessun risultato trovato"
};
// valore che passiamo come limit quando non vogliamo Limitare i risultati (visto che il server se non glielo passi limita a 20)
// il server limita comunque a 2000 anche se gli metto un numero più alto
const NO_LIMIT = 2000;
var OrganigrammaMode;
(function (OrganigrammaMode) {
  OrganigrammaMode["DETTAGLIO"] = "DETTAGLIO";
  OrganigrammaMode["RUBRICA"] = "RUBRICA";
  OrganigrammaMode["DESTINATARI"] = "DESTINATARI";
})(OrganigrammaMode || (OrganigrammaMode = {}));
const ADDITIONAL_DATA = {
  azienda: {},
  utente: {},
  struttura: {},
  utentestruttura: {
    filterCombo: "filterCombo"
  },
  strutturaunificata: {}
};
const TIPO_OPERAZIONE = {
  fusione: "FUSIONE",
  replica: "REPLICA"
};
const TIPI_OPERAZIONE = [TIPO_OPERAZIONE.fusione, TIPO_OPERAZIONE.replica];
const STATI_STR_UNIFICATE = {
  Bozza: "Bozza",
  Corrente: "Corrente",
  Storico: "Storico",
  ByData: "ByData"
};
const AFFERENZA_STRUTTURA = {
  DIRETTA: 1,
  FUNZIONALE: 3,
  UNIFICATA: 9,
  TEST: 7
};
class CommonToolsModule {
  /** @nocollapse */static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: CommonToolsModule,
    deps: [],
    target: i0.ɵɵFactoryTarget.NgModule
  });
  /** @nocollapse */
  static ɵmod = i0.ɵɵngDeclareNgModule({
    minVersion: "14.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: CommonToolsModule,
    declarations: [BeautifyEnumPipe],
    exports: [BeautifyEnumPipe]
  });
  /** @nocollapse */
  static ɵinj = i0.ɵɵngDeclareInjector({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: CommonToolsModule,
    providers: [IntimusClientService, BackendUtilityService, BeautifyEnumPipe, GenericTreeBds]
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: CommonToolsModule,
  decorators: [{
    type: NgModule,
    args: [{
      imports: [],
      declarations: [BeautifyEnumPipe],
      exports: [BeautifyEnumPipe],
      providers: [IntimusClientService, BackendUtilityService, BeautifyEnumPipe, GenericTreeBds]
    }]
  }]
});

/**
 * reuse-strategy.ts
 * based on solution of corbfon 1/6/17
 * https://stackoverflow.com/questions/41280471/how-to-implement-routereusestrategy-shoulddetach-for-specific-routes-in-angular
 */
class ReuseStrategyParams {
  componentsReuseMap = [];
}
class CustomReuseStrategy {
  /**
   * Object which will store RouteStorageObjects indexed by keys
   * The keys will all be a path (as in route.routeConfig.path)
   * This allows us to see if we've got a route stored for the requested path
   */
  storedRoutes = {};
  /**
   * Contiene l'elenco dei path dei componenti da caricare dalla cache. E' possibile inserire un "*" per indicare di caricare dalla cache il componente
   * corrsipondente al path nel quale si sta andando.
   * Ogni volta che il componente viene trovato, ne viene rimosso il riferimento dalla lista.
   * La viariabile è statica ed è utilizzabile da tutta l'applicazione.
   * @type {Array}
   */
  static componentsReuseList = [];
  /**
   * Decides when the route should be stored
   * If the route should be stored, I believe the boolean is indicating to a controller whether or not to fire this.store
   * _When_ it is called though does not particularly matter, just know that this determines whether or not we store the route
   * An idea of what to do here: check the route.routeConfig.path to see if it is a path you would like to store
   * @param route This is, at least as I understand it, the route that the user is currently on, and we would like to know if we want to store it
   * @returns boolean indicating that we want to (true) or do not want to (false) store that route
   */
  shouldDetach(route) {
    // per il momento salvo sempre tutto, poi nel caso si può prevedere che se la lista dei componenti salvati
    // supera un tot di memoria, si sovrascrive l'ultimo
    let detach = true;
    // if (route.queryParams && route.queryParams.save) {
    //   detach = route.queryParams.save === "true";
    // }
    console.log("detaching", route, "return: ", detach);
    return detach;
  }
  /**
   * Constructs object of type `RouteStorageObject` to store, and then stores it for later attachment
   * @param route This is stored for later comparison to requested routes, see `this.shouldAttach`
   * @param handle Later to be retrieved by this.retrieve, and offered up to whatever controller is using
   * this class
   */
  store(route, handle) {
    let storedRoute = {
      snapshot: route,
      handle: handle
    };
    console.log("store:", storedRoute, "into: ", this.storedRoutes);
    // routes are stored by path - the key is the path name, and the handle is stored under it so that you can only ever have one object stored for a single path
    if (route && route.routeConfig && route.routeConfig.path) this.storedRoutes[route.routeConfig.path] = storedRoute;
  }
  /**
   * Determines whether or not there is a stored route and, if there is, whether or not it should
   * be rendered in place of requested route
   * All'interno di componentsReuseList c'è la lista dei componenti da caricare dalla cache,
   * il componente viene caricato se il suo path è presente nella lista.
   * Se il componente viene ricaricato dalla cache, il riferimento viene rimosso da componentsReuseList
   * oppure nella lista troviamo un "*" lo carica dalla cache, altrimenti no
   * @param route The route the user requested
   * @returns boolean indicating whether or not to render the stored route
   */
  shouldAttach(route) {
    console.log("componentsReuseMap", CustomReuseStrategy.componentsReuseList);
    let attach = false;
    if (route && route.routeConfig && route.routeConfig.path) {
      const path = CustomReuseStrategy.componentsReuseList.filter(e => e === route.routeConfig.path);
      if (path && path.length > 0) {
        attach = true;
        CustomReuseStrategy.componentsReuseList = CustomReuseStrategy.componentsReuseList.filter(e => e !== path[0]);
      } else {
        // const star: string = CustomReuseStrategy.componentsReuseList.find((e) => e === "*");
        const star = CustomReuseStrategy.componentsReuseList.filter(value => value === "*");
        if (star && star.length > 0) {
          // if (star) {
          attach = true;
          CustomReuseStrategy.componentsReuseList = CustomReuseStrategy.componentsReuseList.filter(e => e !== star[0]);
        }
      }
    }
    if (attach) {
      // this will be true if the route has been stored before
      let canAttach = false;
      if (route && route.routeConfig && route.routeConfig.path) attach = !!route.routeConfig && !!this.storedRoutes[route.routeConfig.path];
      // this decides whether the route already stored should be rendered in place of the requested route, and is the return value
      // at this point we already know that the paths match because the storedResults key is the route.routeConfig.path
    }
    return attach;
  }
  /**
   * Finds the locally stored instance of the requested route, if it exists, and returns it
   * @param route New route the user has requested
   * @returns DetachedRouteHandle object which can be used to render the component
   */
  retrieve(route) {
    if (!route || !route.routeConfig || !route.routeConfig.path || !this.storedRoutes || !this.storedRoutes[route.routeConfig.path]) return null;
    // return null if the path does not have a routerConfig OR if there is no stored route for that routerConfig
    else {
      /** returns handle when the route.routeConfig.path is already stored */
      console.log("retrieving", "return: ", this.storedRoutes[route.routeConfig.path]);
      let requestedPath = route.routeConfig.path;
      return this.storedRoutes[route.routeConfig.path].handle;
    }
  }
  /**
   * Determines whether or not the current route should be reused
   * @param future The route the user is going to, as triggered by the router
   * @param curr The route the user is currently on
   * @returns boolean basically indicating true if the user intends to leave the current route
   */
  shouldReuseRoute(future, curr) {
    if (!(future.routeConfig === curr.routeConfig)) {
      console.log("deciding to reuse", "future", future.routeConfig, "current", curr.routeConfig, "return: ", future.routeConfig === curr.routeConfig);
    }
    return future.routeConfig === curr.routeConfig;
  }
  /**
   * This nasty bugger finds out whether the objects are _traditionally_ equal to each other, like you might assume someone else would have put this function in vanilla JS already
   * One thing to note is that it uses coercive comparison (==) on properties which both objects have, not strict comparison (===)
   * @param base The base object which you would like to compare another object to
   * @param compare The object to compare to base
   * @returns boolean indicating whether or not the objects have all the same properties and those properties are ==
   */
  compareObjects(base, compare) {
    // loop through all properties in base object
    for (let baseProperty in base) {
      // determine if comparrison object has that property, if not: return false
      if (compare.hasOwnProperty(baseProperty)) {
        switch (typeof base[baseProperty]) {
          // if one is object and other is not: return false
          // if they are both objects, recursively call this comparison function
          case "object":
            if (typeof compare[baseProperty] !== "object" || !this.compareObjects(base[baseProperty], compare[baseProperty])) {
              return false;
            }
            break;
          // if one is function and other is not: return false
          // if both are functions, compare function.toString() results
          case "function":
            if (typeof compare[baseProperty] !== "function" || base[baseProperty].toString() !== compare[baseProperty].toString()) {
              return false;
            }
            break;
          // otherwise, see if they are equal using coercive comparison
          default:
            if (base[baseProperty] != compare[baseProperty]) {
              return false;
            }
        }
      } else {
        return false;
      }
    }
    // returns true only after false HAS NOT BEEN returned through all loops
    return true;
  }
}
class KrintHeaders {
  logga;
}
class UtilityFunctions {
  static cloneObj(c) {
    const row = {};
    for (const prop in c) {
      row[prop] = c[prop];
    }
    return row;
  }
  static buildKrintHeaders(_logga) {
    const krintHeaders = {
      logga: _logga
    };
    const additionalHeaders = {
      krint: window.btoa(JSON.stringify(krintHeaders))
    };
    return additionalHeaders;
  }
  static contentTypesEnabledForPreview = ["text/html", "application/pdf", "text/plain", "image/jpeg", "image/png"];
  /**
   * Fa partire il download dell'allegato passato
   * @param data è il blob dell'allegato
   * @param type è il content-type dell'allegato
   * @param filename
   * @param preview dice se l'allegato deve essere scaricato o aperto in anteprima (laddove sia consentita l'anteprima)
   */
  static downLoadFile(data, type, filename, preview = false) {
    const blob = new Blob([data], {
      type: type
    });
    const url = window.URL.createObjectURL(blob);
    if (preview && this.contentTypesEnabledForPreview.indexOf(type) > -1) {
      const pwa = window.open(url);
      if (!pwa || pwa.closed || typeof pwa.closed === "undefined") {
        alert("L'apertura del pop-up è bloccata dal tuo browser. Per favore disabilita il blocco.");
      } else {
        setTimeout(() => {
          // console.log("FILE = ", filename, type);
          if (type && type === "application/pdf") {
            pwa.document.getElementsByTagName("html")[0].appendChild(document.createElement("head")).appendChild(document.createElement("title")).appendChild(document.createTextNode(filename));
          } else {
            pwa.document.title = filename;
          }
          pwa.document.getElementsByTagName("html")[0].getElementsByTagName("body")[0].getElementsByTagName("img")[0].style.width = "100%";
        }, 0);
      }
    } else {
      const anchor = document.createElement("a");
      anchor.setAttribute("type", "hidden");
      anchor.download = filename;
      anchor.href = url;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    }
  }
  // Encoding UTF-8 ⇢ base64
  static b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt(p1, 16));
    }));
  }
  // Decoding base64 ⇢ UTF-8
  static b64DecodeUnicode(str) {
    return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
  }
}

// backbox

/**
 * Generated bundle index. Do not edit.
 */

export { ADDITIONAL_DATA, AFFERENZA_STRUTTURA, BackendUtilityService, BeautifyEnumPipe, CommonToolsModule, CsvExtractor, CustomReuseStrategy, EntitaBlackbox, GenericFilterService, GenericTreeBds, IntimusClientService, IntimusCommand, IntimusCommands, KrintHeaders, LOCAL_IT, NO_LIMIT, OggettoneOperation, OggettonePermessiEntitaGenerator, OrganigrammaMode, PRIMENG_ITA_TRANSALATION, PermissionManagerService, RefreshMailsParamsEntities, RefreshMailsParamsOperations, ReuseStrategyParams, STATI_STR_UNIFICATE, TIPI_OPERAZIONE, TIPO_OPERAZIONE, UtilityFunctions };
